import { combineReducers } from '@reduxjs/toolkit';

import receiverReducer from './features/receiver/receiverSlice';
import senderReducer from './features/sender/senderSlice';
import transferTypesReducer from './features/transferTypes/transferTypesSlice';
import paymentMethodsReducer from './features/paymentMethods/paymentMethodsSlice';
import networksReducer from './features/networks/networksSlice';
import stepReducer from './features/step/stepSlice';
import productReducer from './features/product/productSlice';
import currenciesReducer from './features/currencies/currenciesSlice';
import transferReducer from './features/transfer/transferSlice';
import loadingReducer from './features/loading/loadingSlice';
import errorReducer from './features/error/errorSlice';

const reducer = combineReducers({
  receiver: receiverReducer,
  sender: senderReducer,
  transferTypes: transferTypesReducer,
  paymentMethods: paymentMethodsReducer,
  networks: networksReducer,
  step: stepReducer,
  product: productReducer,
  currencies: currenciesReducer,
  transfer: transferReducer,
  loading: loadingReducer,
  error: errorReducer,
});

export default reducer;
